import { FieldType, MeasurementUnits } from '../../../../shared/enums';
import { FieldSettingsModel } from '../../common-models/field-settings.model';
import { RangeFieldValidator } from '../../../../shared/zoneiqui/field-validators';
import { ITableFieldsConfiguration } from 'src/app/interfaces/tables/table-fields-configuration.interface';
import { AllowedUseValidator } from 'src/shared/zoneiqui/field-validators/allowed-use.validator';

function usesTableSettingsFactory() {
    return [
        new FieldSettingsModel('AllowedUsesId', FieldType.NUMBER, MeasurementUnits.UNITS, {
            validators: [new AllowedUseValidator()],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('UseLimit', FieldType.NUMBER, MeasurementUnits.UNITS, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('ParkingRequired', FieldType.NUMBER, MeasurementUnits.SPACES_PER_UNIT, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        })
    ];
}

export default { fieldsFactory: usesTableSettingsFactory } as ITableFieldsConfiguration;
